import { headerStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListHeader";
import Filter from "@insite/mobius/Icons/Filter";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerStyles.toggleFilterButton = {
    color: "transparent",
    shadow: false,
    css: css`
        width: 40px;
        padding: 0;
    `,
};

headerStyles.toggleFilterButtonIcon = {
    src: Filter,
    size: 24,
    css: css`
        color: ${getColor("primary")} !important;
    `,
};
